var AddToCartComponent = Vue.component('add-to-cart', {
    props: ['item'],
    data: function() {
        return {
            'quantity': 1
        };
    },
    computed: {
        moduleData: function() {
            return this.item.module_data;
        }
    },
    methods: {
        add: function() {
            this.$store.dispatch('addProduct', this.item, this.quantity, this.moduleData);
        }
    }
});